// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0ee16623] .el-table-column--selection .cell {\n  padding-left: 10px;\n  padding-right: 10px;\n}", ""]);
// Exports
module.exports = exports;
